import React from 'react';
import { Star, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-24 lg:pt-20 lg:pb-32 relative z-10" data-id="element-33">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center" data-id="element-34">
        {/* Left Column - Content */}
        <div className="lg:col-span-6 flex flex-col items-start" data-id="element-35">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#EAE4D3] border border-[#DCD4BE] mb-8" data-id="element-36">
            <Star className="w-3.5 h-3.5 text-brand-gold fill-brand-gold" data-id="element-37" />
            <span className="text-brand-green text-xs font-bold tracking-wider" data-id="element-38">
              EST. 2003 • SINGAPORE
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] font-serif font-bold leading-[1.15] text-brand-text mb-6 text-balance" data-id="element-39">
            新加坡历史最悠久的
            <span className="block text-brand-green mt-2" data-id="element-40">
              专业Escort推荐平台
            </span>
          </h1>

          {/* Description */}
          <p className="text-brand-muted text-base sm:text-lg max-w-lg mb-10 leading-relaxed" data-id="element-41">
            自2003年成立以来，Shiok8一直致力于为您提供最优质、最可靠的Escort服务推荐。让您在繁忙都市中找到最贴心的陪伴体验。
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center gap-4 mb-12 w-full sm:w-auto" data-id="element-42">
            <a href="https://geylang777-6.site/" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-brand-green hover:bg-brand-green-light text-white px-8 py-3.5 rounded-full font-medium transition-all shadow-soft flex items-center justify-center gap-2 group no-underline" data-id="element-43">
              <span data-id="element-44">官网入口</span>
              <span className="text-white/80 text-sm font-normal" data-id="element-45">
                (Enter Website)
              </span>
              <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-46" />
            </a>

            <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-brand-gold hover:bg-brand-gold/90 text-white px-8 py-3.5 rounded-full font-medium transition-all shadow-soft flex items-center justify-center gap-2 group no-underline" data-id="element-47">
              <span data-id="element-48">新加坡春风阁</span>
              <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-49" />
            </a>

            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto border-2 border-brand-green text-brand-green hover:bg-brand-green/5 px-8 py-3.5 rounded-full font-medium transition-all flex items-center justify-center no-underline" data-id="element-50">
              Telegram Channel
            </a>
          </div>

          {/* Social Proof */}
          <div className="flex items-center gap-4" data-id="element-51">
            <div className="flex -space-x-3" data-id="element-52">
              {/* Avatars */}
              <div className="w-10 h-10 rounded-full border-2 border-brand-bg bg-[#D4A373] flex items-center justify-center text-white text-xs font-bold z-40" data-id="element-53">
                A
              </div>
              <div className="w-10 h-10 rounded-full border-2 border-brand-bg bg-[#CCD5AE] flex items-center justify-center text-brand-green text-xs font-bold z-30" data-id="element-54">
                B
              </div>
              <div className="w-10 h-10 rounded-full border-2 border-brand-bg bg-[#E9EDC9] flex items-center justify-center text-brand-green text-xs font-bold z-20" data-id="element-55">
                C
              </div>
              <div className="w-10 h-10 rounded-full border-2 border-brand-bg bg-[#FAEDCB] flex items-center justify-center text-brand-gold text-xs font-bold z-10" data-id="element-56">
                D
              </div>
            </div>
            <p className="text-sm text-brand-muted" data-id="element-57">
              已有{' '}
              <strong className="text-brand-text font-semibold" data-id="element-58">50,000+</strong>{' '}
              位用户信赖我们
            </p>
          </div>
        </div>

        {/* Right Column - Visual */}
        <div className="lg:col-span-6 relative mt-12 lg:mt-0 lg:ml-8" data-id="element-59">
          {/* Main Brand Card */}
          <div className="bg-brand-green rounded-[2rem] p-8 sm:p-12 aspect-[4/3] w-full shadow-soft relative overflow-hidden flex items-center justify-center" data-id="element-60">
            {/* Subtle background gradient/glow inside card */}
            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent pointer-events-none" data-id="element-61" />

            {/* Inner Bordered Box */}
            <div className="border border-white/20 rounded-2xl p-8 sm:p-12 w-3/4 max-w-sm flex flex-col items-center justify-center backdrop-blur-sm relative z-10" data-id="element-62">
              <h2 className="text-4xl sm:text-5xl font-serif text-white mb-3" data-id="element-63">
                Shiok8
              </h2>
              <p className="text-brand-gold text-xs sm:text-sm tracking-[0.2em] font-medium uppercase" data-id="element-64">
                Premium Escort
              </p>
            </div>
          </div>

          {/* Floating Rating Card */}
          <div className="absolute -bottom-6 sm:-bottom-8 -left-4 sm:-left-8 bg-white rounded-2xl p-5 sm:p-6 shadow-float flex items-center gap-4 z-20 border border-black/5" data-id="element-65">
            <div className="w-12 h-12 rounded-full bg-brand-bg flex items-center justify-center flex-shrink-0" data-id="element-66">
              <Star className="w-6 h-6 text-brand-green fill-brand-green" data-id="element-67" />
            </div>
            <div data-id="element-68">
              <div className="text-xl font-bold text-brand-text leading-none mb-1.5" data-id="element-69">
                4.9/5.0
              </div>
              <div className="text-xs sm:text-sm text-brand-muted" data-id="element-70">
                基于 10,000+ 真实评价
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}